import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthProvider } from './context/AuthContext';
import { TextsProvider } from './context/TextsContext';
import AuthCallback from './components/AuthCallback';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import HomePage from './pages/HomePage';
import GiftReveal from './pages/GiftReveal';
import FreeCandleAccept from './pages/FreeCandleAccept';
import AdminPanel from './pages/AdminPanel';
import './App.css';
import './pages/AuthPage.css';
import './pages/Dashboard.css';
import './pages/GiftReveal.css';
import './pages/FreeCandleAccept.css';
import './pages/AdminPanel.css';
import './components/LanguageSwitcher.css';
import './styles/StyleB.css';
import './App.c.css';

// A/B/C Testing Style Hook
function useABTestStyle() {
  const [style, setStyle] = useState('a');
  
  useEffect(() => {
    // Check URL parameter for style
    const params = new URLSearchParams(window.location.search);
    const styleParam = params.get('style')?.toLowerCase();
    
    // Remove all style classes first
    document.documentElement.classList.remove('style-b', 'style-c');
    document.body.classList.remove('style-b', 'style-c');
    
    if (styleParam === 'b') {
      setStyle('b');
      document.documentElement.classList.add('style-b');
      document.body.classList.add('style-b');
    } else if (styleParam === 'c') {
      setStyle('c');
      document.documentElement.classList.add('style-c');
      document.body.classList.add('style-c');
    }
  }, []);
  
  return style;
}

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  useABTestStyle(); // Apply A/B test style
  
  // Check URL fragment for session_id (Google OAuth callback)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/candle/:id" element={<HomePage />} />
      <Route path="/gift/:giftToken" element={<GiftReveal />} />
      <Route path="/free-candle/:token" element={<FreeCandleAccept />} />
      <Route path="/admin" element={<AdminPanel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TextsProvider>
          <AppRouter />
        </TextsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
